import { Button, ButtonGroup, NewsList, Post } from '@tracsis/library/src';
import { ArrowLeft } from '@tracsis/library/src/components/Icon';
import { BUSINESS_UNITS } from '@tracsis/library/src/constants/BusinessUnits';
import { graphql } from 'gatsby';
import React from 'react';

import Page from '../components/Page/Page';
import Seo from '../components/Page/Seo';
import { LINKS } from '../constants/Navigation';

const NewsPost = ({ data, pageContext, location }) => {
	const { story } = pageContext;
	const {
		title,
		intro,
		image,
		seo_title,
		seo_description,
		content,
		date,
		business_unit,
	} = story;

	const canonicalSite = Object.keys(BUSINESS_UNITS)
		.map((key) => BUSINESS_UNITS[key])
		.find((unit) => business_unit === unit.uuid);

	return (
		<Page>
			<Seo
				title={`${seo_title || title} | News | Tracsis`}
				description={seo_description || intro}
				image={image?.filename}
				link={
					canonicalSite
						? [
							{
								rel: 'canonical',
								key: `${canonicalSite.to}/${pageContext.full_slug}`,
								href: `${canonicalSite.to}/${pageContext.full_slug}`,
							},
						]
						: []
				}
			/>

			<Post
				title={title}
				date={date}
				content={content}
				canonicalSite={canonicalSite}
				snippet={
					<ButtonGroup align="left">
						<Button to={LINKS.NEWS} theme="inline">
							<ArrowLeft />
							See all news
						</Button>
					</ButtonGroup>
				}
				url={location.href}
			/>

			<NewsList
				posts={data.posts.edges}
				title="More news"
				background="lightBlue"
				showImages
				defaultImage="/images/news-default-1920.jpg"
				defaultAlt="Tracsis signage on a building"
			/>
		</Page>
	);
};

export const query = graphql`
	query ($slug: String!) {
		posts: allStoryblokEntry(
			filter: {
				field_component: { eq: "news" }
				slug: { ne: $slug }
				field_hidden_boolean: { ne: true }
				field_hide_on_group_boolean: { ne: true }
			}
			limit: 3
			sort: { field_date_string: DESC }
		) {
			totalCount
			edges {
				node {
					...news
				}
			}
		}
	}
`;

export default NewsPost;
